export const SMART_FOLDER_PASTE_NUDGE = {
	// Set once the paste nudge has been displayed; it never shows again for this user.
	VIEWED: 'smart-folder-paste-nudge:viewed',
} as const;

export type SmartFolderPasteNudgeKeys =
	(typeof SMART_FOLDER_PASTE_NUDGE)[keyof typeof SMART_FOLDER_PASTE_NUDGE];

export const SmartFolderPasteNudgeOnboardingKeys = Object.values(
	SMART_FOLDER_PASTE_NUDGE,
) as ReadonlyArray<SmartFolderPasteNudgeKeys>;
